<div class="fat-fill-container">
  @if (fat(); as f) {
  <div class="header">
    <h2>Remplissage de la FAT {{ f.fatNumber || '#' + fatId }}</h2>
    <div class="status-container">
      @if (f.startedBy) {
      <div class="controleur-info mr-6">
        <span class="info-label">CONTRÔLEUR:</span>
        <span class="info-value">{{ f.startedBy.firstName }} {{ f.startedBy.lastName }}</span>
      </div>
      }
      @if (isFatTerminee() || isFatNonConforme()) {
      <button class="btn btn-outline btn-sm mr-4" (click)="exportNonConformities()" [disabled]="isLoadingExport()">
        <mat-icon>print</mat-icon>
        Imprimer la FAT
      </button>
      }
      <span class="status-label">STATUT:</span>
      <span class="status-badge" [attr.data-meta]="f.statusMeta || null"
        [style.background-color]="f.statusColor || null">
        {{ f.status }}
      </span>
    </div>
  </div>
  @if (!isFatEditable()) {
  <div class="alert alert-error">Cette FAT n'est plus modifiable car elle est terminée.</div>
  }
  }

  @if (isLoading()) {
  <div class="loading-spinner">Chargement...</div>
  } @else if (fat(); as f) {
  @if (f.workflowName) {
  <div class="workflow-box">
    <div class="workflow-head">
      <strong>Workflow FAT:</strong> {{ f.workflowName }}
      @if (f.currentStepOrder) {
      <span class="step-pill">Étape {{ f.currentStepOrder }}</span>
      }
      @if (isWorkflowCompleted()) {
      <span class="workflow-completed-badge">Workflow terminé</span>
      }
    </div>
    @if (currentWorkflow(); as workflow) {
    <div class="workflow-steps">
      @for (step of workflow.steps; track step.id || step.stepOrder) {
      <div class="wf-step" [class.current]="f.currentStepOrder === step.stepOrder">
        <span class="wf-step-title">{{ step.stepOrder }}. {{ step.name }}</span>
        <span class="wf-step-status">{{ step.initialStatusName }} -> {{ step.finalStatusName }}</span>
      </div>
      }
    </div>
    }
    @if (workflowPermissions(); as permissions) {
    @if (!permissions.noWorkflow && !isWorkflowCompleted()) {
    <div class="workflow-actions">
      <button class="btn btn-outline btn-sm" [disabled]="!canValidateWorkflow()" (click)="confirmValidate()">Valider la
        FAT</button>
    </div>
    }
    }
  </div>
  }
  <div class="fat-layout">
    <!-- Sidebar avec les catégories -->
    <aside class="categories-sidebar card" [class.collapsed]="isSidebarCollapsed()">
      <div class="sidebar-header">
        <h3>Catégories</h3>
        <button class="btn-toggle-sidebar" (click)="toggleSidebar()" title="Réduire/Agrandir">
          <mat-icon>{{ isSidebarCollapsed() ? 'chevron_right' : 'chevron_left' }}</mat-icon>
        </button>
      </div>
      <div class="categories-list">
        <button *ngFor="let cat of f.categories; let i = index" [class.active]="i === activeCategoryIndex()"
          [class.status-conforme]="getCategoryStatus(cat) === 'conforme'"
          [class.status-non-conforme]="getCategoryStatus(cat) === 'non-conforme'"
          [class.status-incomplete]="getCategoryStatus(cat) === 'incomplete'"
          [class.status-default]="getCategoryStatus(cat) === 'default'" (click)="selectCategory(i)"
          class="category-item" type="button">
          <span class="category-name">{{ cat.name }}</span>
          <mat-icon *ngIf="i === activeCategoryIndex()" class="active-icon">chevron_right</mat-icon>
        </button>
        <button [class.active]="activeCategoryIndex() === f.categories.length"
          (click)="selectCategory(f.categories.length)" class="category-item" type="button">
          <span class="category-name">Signature</span>
          <mat-icon *ngIf="activeCategoryIndex() === f.categories.length" class="active-icon">chevron_right</mat-icon>
        </button>
      </div>
    </aside>

    <!-- Contenu principal -->
    <div class="main-fat-content">
      @if (activeCategoryIndex() === f.categories.length) {
      <div class="category-display">
        <h2 class="category-title">Signatures</h2>
        <div class="signature-section card p-4">
          <mat-tab-group (selectedTabChange)="onSignatureTabChange()">
            <mat-tab label="Contrôleur 1">
              <div class="signature-tab-content p-4">
                @if (getSignature(1); as sig) {
                <div class="signed-info">
                  <p><strong>Nom :</strong> {{ sig.lastName }}</p>
                  <p><strong>Prénom :</strong> {{ sig.firstName }}</p>
                  <p><strong>Date :</strong> {{ sig.signedAt | date:'dd/MM/yyyy à HH:mm' }}</p>
                  <div class="signature-display">
                    <p><strong>Signature :</strong></p>
                    <div class="signature-box signed">
                      <img [src]="sig.signatureData" alt="Signature"
                        *ngIf="sig.signatureData.startsWith('data:image/')">
                      <span *ngIf="!sig.signatureData.startsWith('data:image/')">{{ sig.signatureData }}</span>
                    </div>
                  </div>
                </div>
                } @else {
                @if (canSign()) {
                <div class="signature-form">
                  <p>Veuillez dessiner votre signature pour valider la FAT en tant que Contrôleur 1.</p>
                  <div class="signature-pad-container">
                    <canvas #signatureCanvas1 class="signature-canvas"></canvas>
                  </div>
                  <div class="signature-actions mt-4 flex gap-2">
                    <button class="btn btn-outline" (click)="clearSignature(1)">Effacer</button>
                    <button class="btn btn-primary" (click)="submitSignature(1)"
                      [disabled]="!canSignNow()">Signer</button>
                  </div>
                </div>
                } @else {
                <div class="alert alert-info">
                  <mat-icon>info</mat-icon>
                  <span>Vous n'avez pas les droits pour signer la FAT. Seuls les administrateurs, responsables d'affaire
                    et contrôleurs peuvent signer.</span>
                </div>
                }
                }
              </div>
            </mat-tab>
            <mat-tab [label]="isAnyFieldNonConforme() ? 'Contrôleur 2 (Optionnel)' : 'Contrôleur 2'">
              <div class="signature-tab-content p-4">
                @if (getSignature(2); as sig) {
                <div class="signed-info">
                  <p><strong>Nom :</strong> {{ sig.lastName }}</p>
                  <p><strong>Prénom :</strong> {{ sig.firstName }}</p>
                  <p><strong>Date :</strong> {{ sig.signedAt | date:'dd/MM/yyyy à HH:mm' }}</p>
                  <div class="signature-display">
                    <p><strong>Signature :</strong></p>
                    <div class="signature-box signed">
                      <img [src]="sig.signatureData" alt="Signature"
                        *ngIf="sig.signatureData.startsWith('data:image/')">
                      <span *ngIf="!sig.signatureData.startsWith('data:image/')">{{ sig.signatureData }}</span>
                    </div>
                  </div>
                </div>
                } @else {
                @if (canSign()) {
                <div class="signature-form">
                  <p>{{ isAnyFieldNonConforme() ? 'La FAT contient des non-conformités : la signature du second contrôleur est facultative.' : 'Veuillez dessiner votre signature pour valider la FAT en tant que Contrôleur 2.' }}</p>
                  <div class="signature-pad-container">
                    <canvas #signatureCanvas2 class="signature-canvas"></canvas>
                  </div>
                  <div class="signature-actions mt-4 flex gap-2">
                    <button class="btn btn-outline" (click)="clearSignature(2)">Effacer</button>
                    <button class="btn btn-primary" (click)="submitSignature(2)"
                      [disabled]="!canSignNow()">Signer</button>
                  </div>
                </div>
                } @else {
                <div class="alert alert-info">
                  <mat-icon>info</mat-icon>
                  <span>Vous n'avez pas les droits pour signer la FAT. Seuls les administrateurs, responsables d'affaire
                    et contrôleurs peuvent signer.</span>
                </div>
                }
                }
              </div>
            </mat-tab>
          </mat-tab-group>
        </div>
      </div>
      }
      @if (activeCategory(); as category) {
      <div class="category-display">
        <div class="category-header">
          <h2 class="category-title">{{ category.name }}</h2>

          @if (category.name !== 'Généralités') {
          <div class="category-subcontractor" [class.missing]="isCategorySubcontractorMissing(category)">
            <mat-form-field appearance="outline" class="subcategory-select" [class.subcategory-select-missing]="isCategorySubcontractorMissing(category)">
              <mat-label>Sous-traitant</mat-label>
              <input
                matInput
                [ngModel]="getCategorySubcontractorQuery(category)"
                (ngModelChange)="onCategorySubcontractorQueryChange(category, $event)"
                (blur)="onCategorySubcontractorBlur(category)"
                [matAutocomplete]="subcontractorAuto"
                [disabled]="!isFatEditable() || savingCategories().has(category.id)"
                placeholder="Rechercher un sous-traitant"
              />
              <button
                mat-icon-button
                matSuffix
                type="button"
                title="Effacer le sous-traitant"
                *ngIf="isFatEditable() && (category.subcontractorId || getCategorySubcontractorQuery(category)) && !savingCategories().has(category.id)"
                (click)="clearCategorySubcontractor(category)">
                <mat-icon>close</mat-icon>
              </button>
              <mat-autocomplete
                #subcontractorAuto="matAutocomplete"
                [displayWith]="displaySubcontractor"
                (optionSelected)="onCategorySubcontractorSelected(category, $event.option.value)">
                @for (subcontractor of getFilteredSubcontractors(category); track subcontractor.id) {
                <mat-option [value]="subcontractor">
                  {{ subcontractor.denomination }}
                </mat-option>
                }
              </mat-autocomplete>
              <mat-error *ngIf="isCategorySubcontractorMissing(category)">
                Sous-traitant obligatoire
              </mat-error>
            </mat-form-field>
          </div>
          }
        </div>

        @if (category.name === 'Généralités') {
        <div class="generalites-content card p-4">
          <app-project-documents [projectId]="projectId" [isProjectLocked]="true"
            [readonlyMode]="true"></app-project-documents>
        </div>
        } @else {
        <mat-accordion multi>
          @for (subcategory of category.subcategories; track subcategory.id) {
          <mat-expansion-panel [expanded]="true">
            <mat-expansion-panel-header>
              <mat-panel-title class="subcategory-header">
                <strong>{{ subcategory.name }}</strong>
                <div class="subcategory-status-badge"
                  [class.status-conforme]="getSubcategoryStatus(subcategory) === 'conforme'"
                  [class.status-non-conforme]="getSubcategoryStatus(subcategory) === 'non-conforme'"
                  [class.status-incomplete]="getSubcategoryStatus(subcategory) === 'incomplete'">
                </div>
              </mat-panel-title>
            </mat-expansion-panel-header>

            <div class="fields-grid">
              @for (field of subcategory.fields; track field.id) {
              <div class="field-row" [class.saving]="savingFields().has(field.id)"
                [class.status-non-conforme]="isFieldNonConforme(field)" [class.status-incomplete]="isFieldIncomplete(field)">
                <div class="field-info">
                  <span class="field-name">{{ field.name }}</span>
                </div>

                <div class="field-controls">
                  <mat-form-field appearance="outline" class="result-select">
                    <mat-label>Résultat</mat-label>
                    <mat-select [(ngModel)]="field.result" (selectionChange)="updateField(field)"
                      [disabled]="!isFatEditable()" required>
                      <mat-option [value]="null">Choisir...</mat-option>
                      @for (res of getResults(field.possibleResults); track res) {
                      <mat-option [value]="res">{{ res }}</mat-option>
                      }
                    </mat-select>
                    <mat-error *ngIf="!field.result">Obligatoire</mat-error>
                  </mat-form-field>

                  <div class="comment-container">
                    @if (isCommentMandatory(field) && !field.comment) {
                    <span class="mandatory-comment-hint">commentaire obligatoire</span>
                    }
                    <mat-form-field appearance="outline" class="comment-input">
                      <mat-label>{{ field.commentPlaceholder || 'Commentaire' }}</mat-label>
                      <textarea matInput [(ngModel)]="field.comment" (blur)="updateField(field)"
                        [disabled]="!isFatEditable()" [required]="isCommentMandatory(field)" rows="1"></textarea>
                      <mat-error *ngIf="isCommentMandatory(field) && !field.comment">
                        Commentaire obligatoire
                      </mat-error>
                    </mat-form-field>
                  </div>

                  <!-- Gestion des photos pour les champs de type PHOTO -->
                  <div class="photos-block" *ngIf="field.type === 'PHOTO'">
                    <div class="photos-actions">
                      <button type="button" class="btn btn-secondary" (click)="openPhotosDialog(field)"
                        title="Gérer les photos">
                        <mat-icon aria-hidden="true">photo_library</mat-icon>
                        Gérer les photos ({{ field.photos?.length || 0 }})
                      </button>
                    </div>
                    <mat-error
                      *ngIf="field.result !== 'Non Applicable' && field.minPhotosNbr && (field.photos?.length || 0) < field.minPhotosNbr">
                      Au moins {{ field.minPhotosNbr }} photo(s) requise(s)
                    </mat-error>
                  </div>

                  <!-- Gestion des documents pour les champs de type DOCUMENT -->
                  <div class="photos-block" *ngIf="field.type === 'DOCUMENT'">
                    <div class="photos-actions">
                      <button type="button" class="btn btn-secondary" (click)="openDocumentsDialog(field)"
                        title="Gérer les documents">
                        <mat-icon aria-hidden="true">attach_file</mat-icon>
                        Gérer les documents ({{ field.documents?.length || 0 }})
                      </button>
                    </div>
                    <mat-error *ngIf="field.minPhotosNbr && (field.documents?.length || 0) < field.minPhotosNbr">
                      Au moins {{ field.minPhotosNbr }} document(s) requis
                    </mat-error>
                  </div>

                  @if (savingFields().has(field.id)) {
                  <mat-icon class="saving-icon" aria-hidden="true">sync</mat-icon>
                  }
                </div>
              </div>
              }
            </div>
          </mat-expansion-panel>
          }
        </mat-accordion>
        }
      </div>
      }
    </div>
  </div>
  @if (showConfirmValidate()) {
  <app-confirm-dialog title="Confirmer la validation" message="Voulez-vous valider cette étape de la FAT ?"
    confirmLabel="Valider" (confirmed)="validateWorkflow()" (cancelled)="cancelValidate()"></app-confirm-dialog>
  }

  @if (showValidationErrors()) {
  <app-validation-errors-dialog [title]="validationErrorTitle()" [message]="validationErrorMessage()"
    [errors]="missingCategories()" (close)="closeValidationErrors()">
  </app-validation-errors-dialog>
  }
  }
</div>
